import { useEffect, useReducer } from 'react';
import { subscribe } from 'valtio';

// Re-renders when `select(proxy)` returns a different value (by identity). Use
// it where useSnapshot does not fit: to track proxy identity, which a snapshot
// cannot, or to react to one value without subscribing to everything a
// snapshot of the proxy would read.
export function useProxySelector(proxy, select, deps = []) {
  const current = proxy ? select(proxy) : undefined;
  const [, rerender] = useReducer((n) => n + 1, 0);
  useEffect(() => {
    if (!proxy) return undefined;
    const check = () => {
      if (select(proxy) !== current) rerender();
    };
    check(); // the value may have changed between render and subscribe
    return subscribe(proxy, check);
  }, [proxy, current, ...deps]); // eslint-disable-line react-hooks/exhaustive-deps
  return current;
}
